import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { QuemSomos } from "@/components/QuemSomos";
import { Servicos } from "@/components/Servicos";
import { PorQueEscolher } from "@/components/PorQueEscolher";
import { Testemunhos } from "@/components/Testemunhos";
import { Contacto } from "@/components/Contacto";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Seo } from "@/components/Seo";
import FisioterapiaPage from "@/pages/Fisioterapia";
import PilatesPage from "@/pages/Pilates";
import GyrotonicPage from "@/pages/Gyrotonic";
import PowerPlatePage from "@/pages/PowerPlate";
import TreinoClinicoPage from "@/pages/TreinoClinico";
import OsteopatiaPage from "@/pages/Osteopatia";
import PsicologiaPage from "@/pages/Psicologia";
import MedicinaChinesaPage from "@/pages/MedicinaChinesa";
import TerapiaFalaPage from "@/pages/TerapiaFala";

const Landing = () => {
  return (
    <div className="App" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <QuemSomos />
        <Servicos />
        <PorQueEscolher />
        <Testemunhos />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Seo />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/fisioterapia" element={<FisioterapiaPage />} />
          <Route path="/pilates-clinico" element={<PilatesPage />} />
          <Route path="/gyrotonic" element={<GyrotonicPage />} />
          <Route path="/power-plate" element={<PowerPlatePage />} />
          <Route path="/treino-clinico" element={<TreinoClinicoPage />} />
          <Route path="/osteopatia" element={<OsteopatiaPage />} />
          <Route path="/psicologia" element={<PsicologiaPage />} />
          <Route path="/medicina-chinesa" element={<MedicinaChinesaPage />} />
          <Route path="/terapia-fala" element={<TerapiaFalaPage />} />
        </Routes>
        <WhatsAppFloat />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#F9F8F6",
            color: "#2A322C",
            border: "1px solid #E5E2DC",
            borderRadius: 0,
          },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
